let pdfMake = import('pdfmake/build/pdfmake')
let fonts = import('./pdfmake-fonts.js')

export default async function getPdfMake() {
  let makePdf = (await pdfMake).default
  makePdf.vfs = (await fonts).default

  return makePdf
}
